const tipoDisciplina = {
  tfg: 4,
  trabalhoConclusaCurso: 6,

  estagio: 7,
}

export default tipoDisciplina
